"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(uri, options) {
    try {
        const body = JSON.parse(String(options.body));
        if (Array.isArray(body))
            return uri;
        const { operationName } = body;
        return `${uri}?operationName=${operationName}`;
    }
    catch (error) {
        return uri;
    }
}
exports.default = default_1;
